
import store from '@/store';
import SessionsModule, { SortDirection, SortType } from '@/store/modules/Sessions';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

const sessionModule = getModule(SessionsModule, store);

@Component({})
export default class SessionSortBtn extends Vue {
    @Prop({
        type: String,
        required: true
    })
    public field!: SortType;

    @Prop({
        type: Boolean,
        required: false,
        default: false
    })
    public outlined!: boolean;

    @Prop({
        type: Boolean,
        required: false,
        default: false
    })
    public rounded!: boolean;

    click() {
        sessionModule.updateSort(this.field);
    }

    get currentField() {
        return sessionModule.sortData.current;
    }

    get currentDirection(): SortDirection {
        return sessionModule.sortData[this.field];
    }

    get iconClass() {
        switch (this.field) {
            case SortType.name:
                return this.currentDirection === SortDirection.ASC ?
                    'mdi-sort-alphabetical-ascending' :
                    'mdi-sort-alphabetical-descending';
            case SortType.time:
                return this.currentDirection === SortDirection.ASC ?
                    'mdi-sort-clock-ascending-outline' :
                    'mdi-sort-clock-descending-outline';
        }
    }
}

